import AdLocation from "@/models/AdLocation";

export interface LocationAspect {
  id: string;
  label: string;
  slug: string;
  code: AdLocation;
  abbrev: string;
}

export interface FlatLocationAspect extends LocationAspect {
  level: number;
  topId?: string;
}

export interface HierarchyLocationAspect extends LocationAspect {
  children: HierarchyLocationAspect[];
}

// AJB: this group and flatten business still make sense?
export function FlattenLocations(
  aspects: HierarchyLocationAspect[],
  level: number = 0,
  topId?: string
): FlatLocationAspect[] {
  return aspects.flatMap((aspect) => [
    {
      id: aspect.id.toString(),
      label: aspect.label,
      slug: aspect.slug,
      code: aspect.code,
      abbrev: aspect.abbrev,
      level: level,
      topId: topId ?? aspect.id,
    },
    ...FlattenLocations(aspect.children, level + 1, topId ?? aspect.id),
  ]);
}

const LOCATION_HIERARCHY: HierarchyLocationAspect[] = [
  {
    id: "1",
    label: "Australia",
    slug: "australia",
    code: "AU",
    abbrev: "AU",
    children: [
      {
        id: "11",
        label: "New South Wales",
        slug: "new-south-wales",
        code: "AU_NSW",
        abbrev: "NSW",
        children: [],
      },
      {
        id: "12",
        label: "Victoria",
        slug: "victoria",
        code: "AU_VIC",
        abbrev: "VIC",
        children: [],
      },
      {
        id: "13",
        label: "Queensland",
        slug: "queensland",
        code: "AU_QLD",
        abbrev: "QLD",
        children: [],
      },
      {
        id: "14",
        label: "Western Australia",
        slug: "western-australia",
        code: "AU_WA",
        abbrev: "WA",
        children: [],
      },
      {
        id: "15",
        label: "South Australia",
        slug: "south-australia",
        code: "AU_SA",
        abbrev: "SA",
        children: [],
      },
      {
        id: "16",
        label: "Tasmania",
        slug: "tasmania",
        code: "AU_TAS",
        abbrev: "TAS",
        children: [],
      },
      {
        id: "17",
        label: "Northern Territory",
        slug: "northern-territory",
        code: "AU_NT",
        abbrev: "NT",
        children: [],
      },
      {
        id: "18",
        label: "Australian Capital Territory",
        slug: "australian-capital-territory",
        code: "AU_ACT",
        abbrev: "ACT",
        children: [],
      },
    ],
  },
  {
    id: "2",
    label: "New Zealand",
    slug: "new-zealand",
    code: "NZ",
    abbrev: "NZ",
    children: [
      {
        id: "19",
        label: "North Island",
        slug: "north-island",
        code: "NZ_NI",
        abbrev: "NZ",
        children: [],
      },
      {
        id: "20",
        label: "South Island",
        slug: "south-island",
        code: "NZ_SI",
        abbrev: "NZ",
        children: [],
      },
    ],
  },
];

export default LOCATION_HIERARCHY;
